import { ModuleWithProviders, NgModule } from '@angular/core';

import { IEnvironment } from './models/environment.interface';
import { ENVIRONMENT } from './tokens/environment.token';

@NgModule()
export class SonaEnvironmentModule {
    /**
     * Provides the {@link ENVIRONMENT} token globally
     *
     * @param environment the environment object to provide via the {@link ENVIRONMENT} token
     */
    static forRoot(
        environment: IEnvironment
    ): ModuleWithProviders<SonaEnvironmentModule> {
        return {
            ngModule: SonaEnvironmentModule,
            providers: [ { provide: ENVIRONMENT, useValue: environment } ]
        };
    }
}
